import { Col, Row } from 'react-bootstrap';
import ImgContainer from './imgContainer';

import banamex from 'assets/img/bancos/banamex.png';

import { bancos } from 'helpers/dataBancos';

const { santander, bancomer } = bancos;

const ButtonsBancos = ({ isAyuntamiento = false, dataBBVA, dataSant, isTenencia, isHojaMillar }) => {

  const FormBBVA = () => {
    if (isAyuntamiento || isHojaMillar) return null;

    return <Col sm='2'>
      <form name='form' method='post' action='https://www.adquiramexico.com.mx/clb/endpoint/ggro/'>
        <input name='s_transm' type='hidden' value={dataBBVA.s_transm} />
        <input name='c_referencia' type='hidden' value={dataBBVA.ref} />
        <input name='t_servicio' type='hidden' value={dataBBVA.t_servicios} />
        <input name='t_importe' type='hidden' value={dataBBVA.dataForm.t_importe} />
        <input name='val_1' type='hidden' value={dataBBVA.dataForm.val_1} />
        <input name='val_2' type='hidden' value={dataBBVA.dataForm.val_2} />
        <input name='val_3' type='hidden' value={bancomer.val_3} />
        <input name='val_4' type='hidden' value={bancomer.val_4} />
        <input name='val_5' type='hidden' value={bancomer.val_5} />
        <input name='val_6' type='hidden' value={bancomer.val_6} />
        <button className='button-no-style'>
          <div className='btn-test'>
            <ImgContainer>
              <img src={bancomer.imagen} alt='visa' />
            </ImgContainer>
          </div>
        </button>
      </form>
    </Col>
  }

  const FormBanamex = () => {
    if (isAyuntamiento || dataBBVA.dataForm.val_1 !== '0' || isHojaMillar) return null;

    return <Col sm='2'>
      <ImgContainer >
        <img src={banamex} alt='visa' />
      </ImgContainer>
    </Col>;
  }

  const FormSant = () => {
    if (!isAyuntamiento && dataBBVA.dataForm.val_1 !== '0') return null;
    
    return <Col sm='2'>
      <form name='form' method='post' action='https://www.santander.com.mx/Supernet2007/homeMicrositio.jsp'>
        <input name='url_resp' type='hidden' value={santander.url_resp} />
        <input name='convenio' type='hidden' value={dataSant.convenio} />
        <input name='referencia' type='hidden' value={dataSant.ref} />
        <input name='importe' type='hidden' value={dataSant.t_importe} />
        <button className='btn-test'>
          <ImgContainer>
            <img src={santander.imagen} alt='Santander' />
          </ImgContainer>
        </button>
      </form>
    </Col>;
  }

  return (
    <Row className='justify-content-md-center' >
      <FormBBVA />
      <FormSant />
      <FormBanamex />
    </Row>
  )
}

export default ButtonsBancos

export const Bbva = ({ isAyuntamiento = false, dataBBVA }) => {
  if (isAyuntamiento) return null;

  return (<Col sm='2'>
    <form name='form' method='post' action='https://www.adquiramexico.com.mx/clb/endpoint/ggro/'>
      <input name='s_transm' type='hidden' value={dataBBVA.s_transm} />
      <input name='c_referencia' type='hidden' value={dataBBVA.ref} />
      <input name='t_servicio' type='hidden' value={dataBBVA.t_servicios} />
      <input name='t_importe' type='hidden' value={dataBBVA.dataForm.t_importe} />
      <input name='val_1' type='hidden' value={dataBBVA.dataForm.val_1} />
      <input name='val_2' type='hidden' value={dataBBVA.dataForm.val_2} />
      <input name='val_3' type='hidden' value={bancomer.val_3} />
      <input name='val_4' type='hidden' value={bancomer.val_4} />
      <input name='val_5' type='hidden' value={bancomer.val_5} />
      <input name='val_6' type='hidden' value={bancomer.val_6} />
      <button className='button-no-style'>
        <div className='btn-test'>
          <ImgContainer>
            <img src={bancomer.imagen2} alt='visa' />
          </ImgContainer>
        </div>
      </button>
    </form>
  </Col>
  )
}
